import { memo, ReactElement, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { IDictionary } from '~/services/api/dictionaries/types';
import RadioGroup from '~/ui/components/inputs/RadioGroup';

interface IProps {
  teams: (IDictionary & { isPrimary: boolean })[];
  fieldName: string;
}

// fieldName - teamId_${clientId}_${memberId}
const TeamsField = ({ teams, fieldName }: IProps): ReactElement => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const defaultValue = String(teams.find(team => team.isPrimary)?.id || teams[0].id);

  useEffect(() => {
    setValue(fieldName, defaultValue);
  }, [defaultValue, fieldName, setValue]);

  return (
    <RadioGroup
      control={control}
      name={fieldName}
      errors={errors}
      options={teams.map(team => ({
        label: team.name,
        value: String(team.id),
      }))}
      size="small"
    />
  );
};

export default memo(TeamsField);
